import axios from 'axios'
import router from '../router'
import store from '../store'

export const getRefreshToken = async () => {
  const { user } = store.state
  if (user.token && user.refreshToken) {
    const { username, userId, remember, ...tokenBody } = user
    try {
      const res = await axios.post('/token', { ...tokenBody })
      const refreshUser = {
        username,
        userId,
        remember,
        token: res.data.token,
        refreshToken: tokenBody.refreshToken,
      }
      store.dispatch('UPDATE_USER_INFO', refreshUser)
      return refreshUser.token
    } catch (error) {
      setTimeout(() => {
        router.push({ path: '/login' })
      })
      return Promise.reject(error)
    }
  }
  return false
}

export default {}
